module.exports = __webpack_public_path__ + "img/Success-Illustration.1d9ce7c2.svg";